'use client';

import { useSetAtom } from 'jotai';
import { useLayoutEffect } from 'react';
import { PC_BREAKPOINT } from '@weberus/utils';
import { pcWidthAtom } from '../store/device';

/**
 * PC 넓이인지 확인하는 저장하는 훅
 * !! WARNING: 이 hook은 global-provider 에서만 사용 가능
 */
const useRegisterIsPcWidth = () => {
  const setPcWidth = useSetAtom(pcWidthAtom);

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${PC_BREAKPOINT}px)`);
    setPcWidth({ isPcWidth: mediaQuery.matches, initialized: true }); // 초기값 설정

    const handleMediaChange = (event: MediaQueryListEvent) => {
      setPcWidth({ isPcWidth: event.matches, initialized: true });
    };

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);
};

export default useRegisterIsPcWidth;
